<template>
  <v-container fluid fill-height>
    <v-row
      v-if="samplesToSend.length != 0"
      class="d-flex justify-center my-0 py-0"
    >
      <v-col class="text-center" lg="6">
        {{ translations.send_label }} kit {{ samplesToSend.length }}
        {{
          samplesToSend.length > 1
            ? translations.action_samples
            : translations.label_sample
        }}
        <v-btn
          color="primary"
          small
          class="ml-2"
          rounded
          @click="showKitTypeModal = true"
        >
          <v-icon>
            mdi-send
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center my-0 py-0">
      <v-col cols="9" xl="7" lg="7" md="7" sm="7">
        <v-autocomplete
          v-model="statusSelected"
          dense
          hide-details=""
          @change="selectionChanged"
          :items="status"
          item-text="name"
          :label="translations.label_status"
          background-color="white"
          outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-btn
          :loading="loading"
          color="success"
          small
          @click="filters = !filters"
        >
          <v-icon v-if="filters"> mdi-filter-minus </v-icon>
          <v-icon v-else> mdi-filter-menu </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center my-0 py-0" v-if="filters">
      <v-col cols="10">
        <v-expand-transition>
          <v-row class="mt-0 mb-2">
            <v-card elevation="3" width="100%" flat class="rounded-lg">
              <v-card-title class="py-2 text-subtitle-1"
                >{{ translations.label_advanced_filters }}
                <v-spacer></v-spacer>
                <v-btn
                  small
                  color="orange"
                  class="mr-2"
                  dark
                  @click="deleteFilters"
                >
                  <v-icon> mdi-filter-off </v-icon>
                </v-btn>
                <v-btn
                  v-if="area_selected_input == 'Todas'"
                  small
                  color="primary"
                  dark
                  @click="applyFilter"
                >
                  {{ translations.label_apply }}
                </v-btn>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-container>
                  <v-row class="px-4 py-0">
                    <v-text-field
                      :error="errorInput"
                      :error-messages="errorMessages"
                      v-model="codeKitSelected"
                      class="py-0"
                      :label="translations.label_analysis_folio"
                      prepend-icon="mdi-receipt"
                      :loading="loading"
                    ></v-text-field>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-row>
        </v-expand-transition>
      </v-col>
    </v-row>
    <v-row v-if="loading">
      <v-col cols="12" v-for="item in 6" :key="item" class="py-2">
        <v-skeleton-loader
          type="list-item-av
        atar-three-line"
        />
      </v-col>
    </v-row>
    <v-row v-else class="mb-5">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="4"
        sm="6"
        xs="12"
        v-for="sample in samples"
        :key="sample.id"
        no-gutters
        class="py-2"
      >
        <sample-item
          :sample="sample"
          @addSample="addSampleToSend"
          @removeSample="removeSampleToSend"
        ></sample-item>
      </v-col>
    </v-row>
    <div class="overlayCenter" v-if="!loading && samples.length <= 0">
      <p class="text-center">{{ translations.label_no_samples }}</p>
    </div>
    <!-- copyright -->
    <v-footer class="text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
    <kit-type-modal v-model="showKitTypeModal" @getKitType="goToGuide" />
  </v-container>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import SampleItem from "@/components/territory/SampleItem.vue";
import KitTypeModal from "@/components/territory/modals/KitTypeModal.vue";

export default {
  data: () => ({
    page: 0,
    isMoreData: true,
    area_selected_input: null,
    statusSelected: null,
    status: [],
    areasLabels: ["Todas"],
    samples: [],
    samplesAux: [],
    loading: false,
    filters: false,
    typeKitSelected: "Ambos",
    codeKitSelected: "",
    codeLength: 7,
    errorInput: false,
    errorMessages: [],
    busyGettingData: false,
    samplesToSend: [],
    showKitTypeModal: false,
  }),
  components: {
    SampleItem,
    KitTypeModal,
  },
  created() {
    this.status = [
      { name: this.translations.status_samples["ALL"], value: "ALL" },
      {
        name: this.translations.status_samples["IN_PROGRESS"],
        value: "IN_PROGRESS",
      },
      {
        name: this.translations.status_samples["VALIDATED"],
        value: "VALIDATED",
      },
      { name: this.translations.status_samples["RECEIVED"], value: "RECEIVED" },
      {
        name: this.translations.status_samples["MEASURING"],
        value: "MEASURING",
      },
      { name: this.translations.status_samples["MEASURED"], value: "MEASURED" },
      {
        name: this.translations.status_samples["VALUATING"],
        value: "VALUATING",
      },
      { name: this.translations.status_samples["VALUATED"], value: "VALUATED" },
    ];
  },
  methods: {
    ...mapActions("areasList", ["fetchAllAreas", "getAreaById"]),
    ...mapActions("samples", [
      "getSamplesById",
      "getAllSamples",
      "getAllSamplesByKit",
      "getSamplesFiltered",
    ]),

    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapMutations("samples", ["SET_AREA_SELECTED_SAMPLE", "SET_DATA_GUIDE"]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),

    async getSoilAreas() {
      try {
        this.loading = true;
        const response = await this.fetchAllAreas(this.organizationId);
        response ? (this.loading = false) : null;
      } catch (error) {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: error,
          timeout: 4000,
        });
      }
      this.loading = false;
    },
    async selectionChanged() {
      this.loading = true;
      this.page = 0;
      this.isMoreData = true;
      try {
        if (this.$route.params.areaId) {
          let response = await this.getSamplesFiltered({
            areaId: this.$route.params.areaId,
            status: this.statusSelected,
            page: this.page,
          });
          if (response) {
            if (!response.error) {
              this.samples = response.samples;
              this.page++;
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          let clientId = null;
          let user = JSON.parse(localStorage.getItem("user"));
          if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
            clientId = localStorage.getItem("organizationId");
          } else {
            clientId = localStorage.getItem("clientId");
          }
          let response = await this.getSamplesFiltered({
            client: clientId,
            status: this.statusSelected,
            page: this.page,
          });
          if (response) {
            if (!response.error) {
              this.samples = response.samples;
              this.page++;
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.loading = false;
    },
    sortSamples(samples) {
      samples.sort((a, b) => {
        if (a.status === "NOT_STARTED") {
          var dateA = new Date(a.updatedAt);
        } else if (a.status === "IN_PROGRESS") {
          var dateA = new Date(a.startDate);
        } else if (
          a.status === "VALIDATED" ||
          a.status === "MEASURING" ||
          a.status === "MEASURED"
        ) {
          var dateA = new Date(a.endDate);
        } else if (a.status === "SENT") {
          var dateA = new Date(a.endDate);
        } else if (a.status === "RECEIVED") {
          var dateA = new Date(a.endDate);
        } else if (a.status === "ANALYZING") {
          var dateA = new Date(a.endDate);
        } else if (a.status === "ANALYZED") {
          var dateA = new Date(a.endDate);
        }

        if (b.status === "NOT_STARTED") {
          var dateB = new Date(b.updatedAt);
        } else if (b.status === "IN_PROGRESS") {
          var dateB = new Date(b.startDate);
        } else if (
          b.status === "VALIDATED" ||
          b.status === "MEASURING" ||
          b.status === "MEASURED"
        ) {
          var dateB = new Date(b.endDate);
        } else if (b.status === "SENT") {
          var dateB = new Date(b.endDate);
        } else if (b.status === "RECEIVED") {
          var dateB = new Date(b.endDate);
        } else if (b.status === "ANALYZING") {
          var dateB = new Date(b.endDate);
        } else if (b.status === "ANALYZED") {
          var dateB = new Date(b.endDate);
        }
        return dateB - dateA;
      });

      let subs = [];
      samples.forEach((item) => {
        if (item.status !== "NOT_STARTED") {
          subs.push(item);
        }
      });

      return subs;
    },
    goBackTerritory() {
      this.$router.push("/territory");
    },
    deleteFilters() {
      this.typeKitSelected = "Ambos";
      this.codeKitSelected = "";

      if (this.samplesAux.length > 0) {
        this.samples = this.samplesAux;
      }

      this.samplesAux = [];
    },
    async applyFilter() {
      if (
        this.area_selected_input == "Todas" &&
        this.codeKitSelected.length <= this.codeLength &&
        this.codeKitSelected.length > 0
      ) {
        let typeKit = this.typeKitSelected;

        if (typeKit == "Inicial") {
          typeKit = "INITIAL";
        } else if (typeKit == "Seguimiento") {
          typeKit = "MONITORING";
        }

        this.loading = true;
        this.samples = await this.getAllSamplesByKit({
          type: typeKit,
          code: this.codeKitSelected,
        });
        this.loading = false;
      } else {
        if (this.codeKitSelected.length != this.codeLength) {
          this.errorInput = true;
          this.errorMessages.push("Ingresa un folio válido");
        }
      }
    },
    async handleScroll() {
      if (
        window.scrollY + window.innerHeight >=
        document.body.scrollHeight - 50
      ) {
        if (this.$route.params.areaId) {
          if (this.statusSelected && this.isMoreData) {
            if (this.busyGettingData) return;
            this.busyGettingData = true;
            let response = await this.getSamplesFiltered({
              areaId: this.$route.params.areaId,
              status: this.statusSelected,
              page: this.page,
            });
            if (response) {
              if (!response.error) {
                this.samples.push(...response.samples);
                this.page++;
                if (response.samples.length <= 0) {
                  this.isMoreData = false;
                }
              } else {
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.advice_error,
                  timeout: 4000,
                });
              }
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          }
        } else {
          if (this.statusSelected && this.isMoreData) {
            let clientId = null;
            let user = JSON.parse(localStorage.getItem("user"));
            if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
              clientId = localStorage.getItem("organizationId");
            } else {
              clientId = localStorage.getItem("clientId");
            }
            if (this.busyGettingData) return;
            this.busyGettingData = true;
            let response = await this.getSamplesFiltered({
              client: clientId,
              status: this.statusSelected,
              page: this.page,
            });

            if (response) {
              if (!response.error) {
                this.samples.push(...response.samples);
                for (let sample of this.samples) {
                  if (
                    this.samplesToSend.find(
                      (element) =>
                        element._id.toString() == sample._id.toString()
                    )
                  ) {
                    sample.sampleSelected = true;
                  }
                }
                this.page++;
                if (response.samples.length <= 0) {
                  this.isMoreData = false;
                }
              } else {
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: this.translations.advice_error,
                  timeout: 4000,
                });
              }
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          }
        }
        this.busyGettingData = false;
      }
    },
    goBack() {
      this.$router.push(`/seller-list/client/`);
    },
    async init() {
      this.loading = true;
      try {
        if (this.$route.params.areaId) {
          this.statusSelected = "ALL";
          let response = await this.getSamplesFiltered({
            areaId: this.$route.params.areaId,
            status: this.statusSelected,
            page: this.page,
          });
          if (response) {
            if (!response.error) {
              this.samples = response.samples;
              this.page++;
              window.addEventListener("scroll", this.handleScroll);
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
          this.SET_APPBAR_OPTIONS({
            leftButton: "back-arrow",
            funcLeftButton: this.goBackTerritory,
          });
        } else {
          let clientId = null;
          let user = JSON.parse(localStorage.getItem("user"));
          if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
            clientId = localStorage.getItem("organizationId");
            this.SET_APPBAR_OPTIONS({
              leftButton: "menu",
            });
          } else {
            clientId = localStorage.getItem("clientId");
            this.SET_APPBAR_OPTIONS({
              leftButton: "menu_seller",
              funcLeftButton: this.goBack,
            });
          }

          this.statusSelected = "ALL";
          let response = await this.getSamplesFiltered({
            client: clientId,
            status: this.statusSelected,
            page: this.page,
          });
          if (response) {
            if (!response.error) {
              this.samples = response.samples;
              for (let sample of this.samples) {
                if (
                  this.samplesToSend.find(
                    (element) => element._id.toString() == sample._id.toString()
                  )
                ) {
                  sample.sampleSelected = true;
                }
              }
              this.page++;
              window.addEventListener("scroll", this.handleScroll);
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.loading = false;
    },
    addSampleToSend(item) {
      this.samplesToSend.push(item);
    },
    removeSampleToSend(item) {
      let index = this.samplesToSend.indexOf(item);
      this.samplesToSend.splice(index, 1);
    },
    goToGuide(kitType) {
      this.SET_DATA_GUIDE({
        samplesGuide: this.samplesToSend,
        kitType: kitType,
      });
      this.$router.push("/sample-guide");
    },
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["soilAreas", "areaSelected"]),
  },
  async mounted() {
    try {
      if (!this.areaSelected && this.$route.params.areaId) {
        let response = await this.getAreaById(this.$route.params.areaId);
        if (response) {
          if (!response.error) {
            this.SET_AREA_SELECTED(response.soilArea);
            await this.init();
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } else {
        this.init();
      }
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: this.translations.advice_error,
        timeout: 4000,
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {},
  watch: {
    async codeKitSelected() {
      this.page = 0;
      this.isMoreData = true;
      this.loading = true;
      this.samples = [];
      if (this.$route.params.areaId) {
        if (this.statusSelected && this.isMoreData) {
          let response = await this.getSamplesFiltered({
            areaId: this.$route.params.areaId,
            status: this.statusSelected,
            page: this.page,
            folio: this.codeKitSelected,
          });
          if (response) {
            if (!response.error) {
              this.samples.push(...response.samples);
              this.page++;
              if (response.samples.length <= 0) {
                this.isMoreData = false;
              }
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        }
      } else {
        let clientId = null;
        let user = JSON.parse(localStorage.getItem("user"));
        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          clientId = localStorage.getItem("organizationId");
        } else {
          clientId = localStorage.getItem("clientId");
        }
        if (this.statusSelected && this.isMoreData) {
          let response = await this.getSamplesFiltered({
            client: clientId,
            status: this.statusSelected,
            page: this.page,
            folio: this.codeKitSelected,
          });
          if (response) {
            if (!response.error) {
              this.samples.push(...response.samples);
              for (let sample of this.samples) {
                if (
                  this.samplesToSend.find(
                    (element) => element._id.toString() == sample._id.toString()
                  )
                ) {
                  sample.sampleSelected = true;
                }
              }
              this.page++;
              if (response.samples.length <= 0) {
                this.isMoreData = false;
              }
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.advice_error,
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}
</style>
